import React from 'react';
import StyledButton from '../../Shared/StyledButton/StyledButton';
import './Styles/Innovative.scss';
import image from '../../../Assets/Cards/boxes.webp';
const Innovative=()=>{
    return(
        <div className="c-innovative">
          <div className="content">
              <h1>The world's most innovative companies use HostDesign everyday to scale design</h1>
              <p>The digital products, from around the world, that you know and love have been built with HostDesign.</p>
              <p>Our customers range from Fortune 100 companies, to startups and schools - all using our online design platform to ideate fast, collaborate and optimise prototypes before development.</p>
              <StyledButton btn="Read Customer Stories" styles="nobg-btn" />
          </div>
          <svg className="wave" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 320">
  <path fill="#fff" fill-opacity="1" d="M0,224L48,213.3C96,203,192,181,288,186.7C384,192,480,224,576,218.7C672,213,768,171,864,176C960,181,1056,235,1152,245.3C1248,256,1344,224,1392,208L1440,192L1440,320L1392,320C1344,320,1248,320,1152,320C1056,320,960,320,864,320C768,320,672,320,576,320C480,320,384,320,288,320C192,320,96,320,48,320L0,320Z"></path>
</svg>
<img src={image} />
        </div>
    )
};
export default Innovative;